// @ts-nocheck
import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  loginSuccess,
  setUserPermissions,
  setThemeMode,
} from '../slices/userSlice';
import { isValueEmpty } from '../../utils/Utils';
import { notifySessionLogin } from '../../utils/sessionBroadcast';

// Listener middleware to sync auth-related state to localStorage.
// These keys are read directly by Axios interceptors and the App bootstrap
// flow, so they must remain in localStorage outside of Redux Persist.
export const userPersistMiddleware = createListenerMiddleware();

userPersistMiddleware.startListening({
  actionCreator: loginSuccess,
  effect: (action) => {
    const { token, refresh, user, profile, remember } = action.payload || {};

    if (token) {
      localStorage.setItem('access_token', token);
    }
    if (refresh) {
      localStorage.setItem('refresh_token', refresh);
    }
    if (user) {
      localStorage.setItem('user_data', JSON.stringify(user));
    }
    if (!isValueEmpty(profile)) {
      localStorage.setItem('profile_data', JSON.stringify(profile));
    }
    if (!isValueEmpty(remember)) {
      localStorage.setItem('remember_me', JSON.stringify(remember));
    }
    // Emit only after the complete login/user state is persisted. Other tabs
    // can now reload without observing a partially initialized common-auth flow.
    notifySessionLogin();
  },
});

userPersistMiddleware.startListening({
  actionCreator: setUserPermissions,
  effect: (action) => {
    localStorage.setItem(
      'user_permissions',
      JSON.stringify(action.payload?.permissions)
    );
  },
});

userPersistMiddleware.startListening({
  actionCreator: setThemeMode,
  effect: (action) => {
    localStorage.setItem('THEME_MODE', action.payload?.themeMode);
  },
});

export default userPersistMiddleware;
